
export const dateFormat: Intl.DateTimeFormatOptions = {
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",

};



export const datetimeFormat: Intl.DateTimeFormatOptions = {
    minute: "2-digit",
    hour: "2-digit",
    second: "2-digit",
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",

};
